export const CREATE_CATEGORY59983 = "CREATE_CATEGORY59983";
export const UPDATE_CATEGORY59983 = "UPDATE_CATEGORY59983";
export const DELETE_CATEGORY59983 = "DELETE_CATEGORY59983";
export const FETCH_CATEGORY59983 = "FETCH_CATEGORY59983";
export const LISTEN_TO_SELECTED_CATEGORY59983 =
  "LISTEN_TO_SELECTED_CATEGORY59983";
export const FILTER_CATEGORY59983 = "FILTER_CATEGORY59983";
